<template>
  <div class="CampaignEditHeader">
    <div v-if="showWarning" class="live-warning"><i class="fa fa-exclamation-circle"></i>
      <div v-if="campaign.hasPausedOffers && campaign.hasPausedWidgets">{{ $t('campaignEdit.warning.pausedBoth') }}</div>
      <div v-else-if="campaign.hasPausedOffers">{{ $t('campaignEdit.warning.pausedOffers') }}</div>
      <div v-else-if="campaign.hasPausedWidgets">{{ $t('campaignEdit.warning.pausedWidgets') }}</div>
      <div v-else-if="campaign.status === 'running'">{{ $t('campaignEdit.warning.live') }}</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CampaignEditHeader',
  props: {
    campaign: {
      type: Object,
      required: true
    }
  },
  methods: {
  },
  computed: {
    showWarning() {
      return this.campaign.hasPausedOffers ||
        this.campaign.hasPausedWidgets ||
        this.campaign.status === 'running'
    }
  }
}

</script>

<style lang="scss">
.live-warning {
  padding: 7px;
  background: #f0ad4e;
  color: #fff;
  box-shadow: 0 1px 2px rgba(0,0,0,0.1);
  border-radius: 1px;
  margin-bottom: 15px;
  i {
    display: inline-block;
    margin-right: 7px;
    margin-left: 3px;
  }
  div {
    display: inline-block;
  }
}

.campaign-notes-link {
  float: right;
  font-size: 80%;
  cursor: pointer;
}
</style>